'use strict';

module.exports.baseProperties = {
  _createDate: {
    type: 'string',
    format: 'date-time'
  },
  _updateDate: {
    type: 'string',
    format: 'date-time'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/baseProperties.js
// module id = 1o2A
// module chunks = 0